var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBiddingStage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 916 564",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient1",
    x1: 0.012,
    y1: 0.021,
    x2: 1,
    y2: 0.964,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient1-2",
    x1: 0.5,
    x2: -2.084,
    y2: 1.515,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bd1822"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1300fd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient1-4",
    x2: -0.587,
    y2: 1.513,
    xlinkHref: "#linear-gradient1-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "infograph",
    transform: "translate(-277 -1514)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26046",
    "data-name": "Group 26046",
    transform: "translate(161.713 1223.787)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_15882",
    "data-name": "Rectangle 15882",
    transform: "translate(115.288 305.213)",
    stroke: "rgba(255,255,255,0.62)",
    strokeWidth: 1,
    fill: "url(#linear-gradient1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 260,
    height: 200,
    rx: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 259,
    height: 199,
    rx: 11.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26032",
    "data-name": "Group 26032",
    transform: "translate(170.072 290.213)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_16151",
    "data-name": "Rectangle 16151",
    d: "M20.215,0H59.891a0,0,0,0,1,0,0V128.228a0,0,0,0,1,0,0H20.215A20.215,20.215,0,0,1,0,108.013v-87.8A20.215,20.215,0,0,1,20.215,0Z",
    transform: "translate(11.987 59.891) rotate(-90)",
    fill: "url(#linear-gradient1-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143573",
    "data-name": "Path 143573",
    d: "M198.2,237.5,186.216,252.9H198.2Z",
    transform: "translate(-186.216 -237.504)",
    fill: "#040a2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143574",
    "data-name": "Path 143574",
    d: "M397.651,237.5,409.638,252.9H397.651Z",
    transform: "translate(-257.436 -237.504)",
    fill: "#040a2b"
  })), /*#__PURE__*/React.createElement("text", {
    id: "STEP_01",
    "data-name": "STEP  01",
    transform: "translate(202.8 329.925)",
    fill: "#fff",
    fontSize: 20,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, "STEP  "), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontSize: 32
  }, "01")), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_16152",
    "data-name": "Rectangle 16152",
    d: "M8.5,0H50.171a8.5,8.5,0,0,1,8.5,8.5v0a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0v0A8.5,8.5,0,0,1,8.5,0Z",
    transform: "translate(219.285 496.201)",
    fill: "#4f08af"
  }), /*#__PURE__*/React.createElement("text", {
    id: "As_soon_as_you_receive_a_bid_from_the_client_acknowledge_the_email_and_put_sales_jaspercolin.com_in_CC_.",
    "data-name": "As soon as you receive a bid from the client, acknowledge the email and put sales@jaspercolin.com in CC\\u200B.",
    transform: "translate(127.287 367.213)",
    fill: "#191817",
    fontSize: 12,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500,
    letterSpacing: "0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 13
  }, "As soon as you receive a bid from the "), /*#__PURE__*/React.createElement("tspan", {
    x: 10,
    y: 35
  }, "client, acknowledge the email and "), /*#__PURE__*/React.createElement("tspan", {
    x: 12,
    y: 57
  }, "put sales@jaspercolin.com in CC\u200B."))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26047",
    "data-name": "Group 26047",
    transform: "translate(489.713 1223.787)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_16200",
    "data-name": "Rectangle 16200",
    transform: "translate(115.288 305.213)",
    stroke: "rgba(255,255,255,0.62)",
    strokeWidth: 1,
    fill: "url(#linear-gradient1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 260,
    height: 200,
    rx: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 259,
    height: 199,
    rx: 11.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26032-2",
    "data-name": "Group 26032",
    transform: "translate(170.072 290.213)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_16151-2",
    "data-name": "Rectangle 16151",
    d: "M20.215,0H59.891a0,0,0,0,1,0,0V128.228a0,0,0,0,1,0,0H20.215A20.215,20.215,0,0,1,0,108.013v-87.8A20.215,20.215,0,0,1,20.215,0Z",
    transform: "translate(11.987 59.891) rotate(-90)",
    fill: "url(#linear-gradient1-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143573-2",
    "data-name": "Path 143573",
    d: "M198.2,237.5,186.216,252.9H198.2Z",
    transform: "translate(-186.216 -237.504)",
    fill: "#040a2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143574-2",
    "data-name": "Path 143574",
    d: "M397.651,237.5,409.638,252.9H397.651Z",
    transform: "translate(-257.436 -237.504)",
    fill: "#040a2b"
  })), /*#__PURE__*/React.createElement("text", {
    id: "STEP_02",
    "data-name": "STEP  02",
    transform: "translate(202.8 329.925)",
    fill: "#fff",
    fontSize: 20,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, "STEP  "), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontSize: 32
  }, "02")), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_16152-2",
    "data-name": "Rectangle 16152",
    d: "M8.5,0H50.171a8.5,8.5,0,0,1,8.5,8.5v0a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0v0A8.5,8.5,0,0,1,8.5,0Z",
    transform: "translate(219.285 496.201)",
    fill: "#4f08af"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Create_a_new_email_chain_with_the_same_subject_line_and_send_the_brief_to_presales_team_removing_client_s_name._No_need_to_put_Sales_in_the_internal_chain_.",
    "data-name": "Create a new email chain with the same subject line and send the brief to \\u201Cpresales team\\u201D removing client\\u2019s name. No need to put \\u201CSales\\u201D in the internal chain\\u200B.",
    transform: "translate(127.287 367.213)",
    fill: "#191817",
    fontSize: 12,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500,
    letterSpacing: "0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 10,
    y: 13
  }, "Create a new email chain with the "), /*#__PURE__*/React.createElement("tspan", {
    x: 3,
    y: 35
  }, "same subject line and send the brief "), /*#__PURE__*/React.createElement("tspan", {
    x: 4,
    y: 57
  }, "to \u201Cpresales team\u201D removing client\u2019s "), /*#__PURE__*/React.createElement("tspan", {
    x: 7,
    y: 79
  }, "name. No need to put \u201CSales\u201D in the "), /*#__PURE__*/React.createElement("tspan", {
    x: 73,
    y: 101
  }, "internal chain\u200B."))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26048",
    "data-name": "Group 26048",
    transform: "translate(817.713 1223.787)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_16201",
    "data-name": "Rectangle 16201",
    transform: "translate(115.288 305.213)",
    stroke: "rgba(255,255,255,0.62)",
    strokeWidth: 1,
    fill: "url(#linear-gradient1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 260,
    height: 200,
    rx: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 259,
    height: 199,
    rx: 11.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26032-3",
    "data-name": "Group 26032",
    transform: "translate(170.072 290.213)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_16151-3",
    "data-name": "Rectangle 16151",
    d: "M20.215,0H59.891a0,0,0,0,1,0,0V128.228a0,0,0,0,1,0,0H20.215A20.215,20.215,0,0,1,0,108.013v-87.8A20.215,20.215,0,0,1,20.215,0Z",
    transform: "translate(11.987 59.891) rotate(-90)",
    fill: "url(#linear-gradient1-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143573-3",
    "data-name": "Path 143573",
    d: "M198.2,237.5,186.216,252.9H198.2Z",
    transform: "translate(-186.216 -237.504)",
    fill: "#040a2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143574-3",
    "data-name": "Path 143574",
    d: "M397.651,237.5,409.638,252.9H397.651Z",
    transform: "translate(-257.436 -237.504)",
    fill: "#040a2b"
  })), /*#__PURE__*/React.createElement("text", {
    id: "STEP_03",
    "data-name": "STEP  03",
    transform: "translate(202.8 329.925)",
    fill: "#fff",
    fontSize: 20,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, "STEP  "), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontSize: 32
  }, "03")), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_16152-3",
    "data-name": "Rectangle 16152",
    d: "M8.5,0H50.171a8.5,8.5,0,0,1,8.5,8.5v0a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0v0A8.5,8.5,0,0,1,8.5,0Z",
    transform: "translate(219.285 496.201)",
    fill: "#4f08af"
  }), /*#__PURE__*/React.createElement("text", {
    id: "As_a_standard_protocol_all_quotations_replies_must_be_sent_within_2_hours_of_receiving_the_project_brief._Follow_up_with_Presales_team_if_this_timeline_is_not_met_.",
    "data-name": "As a standard protocol, all quotations/ replies must be sent within 2 hours of receiving the project brief. Follow up with Presales team if this timeline is not met\\u200B.",
    transform: "translate(127.287 367.213)",
    fill: "#191817",
    fontSize: 12,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500,
    letterSpacing: "0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 35,
    y: 13
  }, "As a standard protocol, all "), /*#__PURE__*/React.createElement("tspan", {
    x: 15,
    y: 35
  }, "quotations/ replies must be sent "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 57
  }, "within 2 hours of receiving the project "), /*#__PURE__*/React.createElement("tspan", {
    x: 4,
    y: 79
  }, "brief. Follow up with Presales team if "), /*#__PURE__*/React.createElement("tspan", {
    x: 45,
    y: 101
  }, "this timeline is not met\u200B."))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26049",
    "data-name": "Group 26049",
    transform: "translate(161.713 1512.787)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_15882-2",
    "data-name": "Rectangle 15882",
    transform: "translate(115.288 305.213)",
    stroke: "rgba(255,255,255,0.62)",
    strokeWidth: 1,
    fill: "url(#linear-gradient1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 260,
    height: 260,
    rx: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 259,
    height: 259,
    rx: 11.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26032-4",
    "data-name": "Group 26032",
    transform: "translate(170.072 290.213)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_16151-4",
    "data-name": "Rectangle 16151",
    d: "M20.215,0H59.891a0,0,0,0,1,0,0V128.228a0,0,0,0,1,0,0H20.215A20.215,20.215,0,0,1,0,108.013v-87.8A20.215,20.215,0,0,1,20.215,0Z",
    transform: "translate(11.987 59.891) rotate(-90)",
    fill: "url(#linear-gradient1-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143573-4",
    "data-name": "Path 143573",
    d: "M198.2,237.5,186.216,252.9H198.2Z",
    transform: "translate(-186.216 -237.504)",
    fill: "#040a2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143574-4",
    "data-name": "Path 143574",
    d: "M397.651,237.5,409.638,252.9H397.651Z",
    transform: "translate(-257.436 -237.504)",
    fill: "#040a2b"
  })), /*#__PURE__*/React.createElement("text", {
    id: "STEP_04",
    "data-name": "STEP  04",
    transform: "translate(202.8 329.925)",
    fill: "#fff",
    fontSize: 20,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, "STEP  "), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontSize: 32
  }, "04")), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_16152-4",
    "data-name": "Rectangle 16152",
    d: "M8.5,0H50.171a8.5,8.5,0,0,1,8.5,8.5v0a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0v0A8.5,8.5,0,0,1,8.5,0Z",
    transform: "translate(219.285 556.201)",
    fill: "#4f08af"
  }), /*#__PURE__*/React.createElement("text", {
    id: "As_soon_as_you_receive_the_reply_from_Presales_make_it_consultative_and_if_you_have_any_queries_drop_another_email_to_the_team._To_make_the_quote_better_ask_for_illustrations_case_studies_targeting_approach_and_other_details_regrading_the_bid._",
    "data-name": "As soon as you receive the reply from Presales, make it consultative and if you have any queries drop another email to the team.\\u200B To make the quote better ask for illustrations, case studies, targeting approach  and other details regrading the bid. \\u200B",
    transform: "translate(127.287 367.213)",
    fill: "#191817",
    fontSize: 12,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500,
    letterSpacing: "0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 13
  }, "As soon as you receive the reply from "), /*#__PURE__*/React.createElement("tspan", {
    x: 5,
    y: 35
  }, "Presales, make it consultative and if "), /*#__PURE__*/React.createElement("tspan", {
    x: 7,
    y: 57
  }, "you have any queries drop another "), /*#__PURE__*/React.createElement("tspan", {
    x: 60,
    y: 79
  }, "email to the team.\u200B"), /*#__PURE__*/React.createElement("tspan", {
    x: 15,
    y: 101
  }, "To make the quote better ask for "), /*#__PURE__*/React.createElement("tspan", {
    x: 6,
    y: 123
  }, "illustrations, case studies, targeting "), /*#__PURE__*/React.createElement("tspan", {
    x: 30,
    y: 145,
    xmlSpace: "preserve"
  }, "approach  and other details "), /*#__PURE__*/React.createElement("tspan", {
    x: 61,
    y: 167
  }, "regrading the bid. \u200B"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26050",
    "data-name": "Group 26050",
    transform: "translate(489.713 1512.787)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_16202",
    "data-name": "Rectangle 16202",
    transform: "translate(115.288 305.213)",
    stroke: "rgba(255,255,255,0.62)",
    strokeWidth: 1,
    fill: "url(#linear-gradient1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 260,
    height: 260,
    rx: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 259,
    height: 259,
    rx: 11.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26032-5",
    "data-name": "Group 26032",
    transform: "translate(170.072 290.213)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_16151-5",
    "data-name": "Rectangle 16151",
    d: "M20.215,0H59.891a0,0,0,0,1,0,0V128.228a0,0,0,0,1,0,0H20.215A20.215,20.215,0,0,1,0,108.013v-87.8A20.215,20.215,0,0,1,20.215,0Z",
    transform: "translate(11.987 59.891) rotate(-90)",
    fill: "url(#linear-gradient1-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143573-5",
    "data-name": "Path 143573",
    d: "M198.2,237.5,186.216,252.9H198.2Z",
    transform: "translate(-186.216 -237.504)",
    fill: "#040a2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143574-5",
    "data-name": "Path 143574",
    d: "M397.651,237.5,409.638,252.9H397.651Z",
    transform: "translate(-257.436 -237.504)",
    fill: "#040a2b"
  })), /*#__PURE__*/React.createElement("text", {
    id: "STEP_05",
    "data-name": "STEP  05",
    transform: "translate(202.8 329.925)",
    fill: "#fff",
    fontSize: 20,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, "STEP  "), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontSize: 32
  }, "05")), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_16152-5",
    "data-name": "Rectangle 16152",
    d: "M8.5,0H50.171a8.5,8.5,0,0,1,8.5,8.5v0a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0v0A8.5,8.5,0,0,1,8.5,0Z",
    transform: "translate(219.285 556.201)",
    fill: "#4f08af"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Enter_pricing_details_and_send_the_quotation_table_to_Amit_on_Teams_for_approval._If_he_doesn_t_reply_within_15_minutes_or_30_minutes_give_him_a_call_directly_for_approval._",
    "data-name": "Enter pricing details and send the quotation table to Amit on Teams for approval. If he doesn\\u2019t reply within 15 minutes or 30 minutes, give him a call directly for approval. \\u200B",
    transform: "translate(127.287 367.213)",
    fill: "#191817",
    fontSize: 12,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500,
    letterSpacing: "0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 12,
    y: 13
  }, "Enter pricing details and send the "), /*#__PURE__*/React.createElement("tspan", {
    x: 2,
    y: 35
  }, "quotation table to Amit on Teams for "), /*#__PURE__*/React.createElement("tspan", {
    x: 2,
    y: 57
  }, "approval. If he doesn\u2019t reply within 15 "), /*#__PURE__*/React.createElement("tspan", {
    x: 11,
    y: 79
  }, "minutes or 30 minutes, give him a "), /*#__PURE__*/React.createElement("tspan", {
    x: 39,
    y: 101
  }, "call directly for approval. \u200B"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26051",
    "data-name": "Group 26051",
    transform: "translate(817.713 1512.787)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_16203",
    "data-name": "Rectangle 16203",
    transform: "translate(115.288 305.213)",
    stroke: "rgba(255,255,255,0.62)",
    strokeWidth: 1,
    fill: "url(#linear-gradient1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 260,
    height: 260,
    rx: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 259,
    height: 259,
    rx: 11.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26032-6",
    "data-name": "Group 26032",
    transform: "translate(170.072 290.213)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_16151-6",
    "data-name": "Rectangle 16151",
    d: "M20.215,0H59.891a0,0,0,0,1,0,0V128.228a0,0,0,0,1,0,0H20.215A20.215,20.215,0,0,1,0,108.013v-87.8A20.215,20.215,0,0,1,20.215,0Z",
    transform: "translate(11.987 59.891) rotate(-90)",
    fill: "url(#linear-gradient1-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143573-6",
    "data-name": "Path 143573",
    d: "M198.2,237.5,186.216,252.9H198.2Z",
    transform: "translate(-186.216 -237.504)",
    fill: "#040a2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143574-6",
    "data-name": "Path 143574",
    d: "M397.651,237.5,409.638,252.9H397.651Z",
    transform: "translate(-257.436 -237.504)",
    fill: "#040a2b"
  })), /*#__PURE__*/React.createElement("text", {
    id: "STEP_06",
    "data-name": "STEP  06",
    transform: "translate(202.8 329.925)",
    fill: "#fff",
    fontSize: 20,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, "STEP  "), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontSize: 32
  }, "06")), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_16152-6",
    "data-name": "Rectangle 16152",
    d: "M8.5,0H50.171a8.5,8.5,0,0,1,8.5,8.5v0a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0v0A8.5,8.5,0,0,1,8.5,0Z",
    transform: "translate(219.285 556.201)",
    fill: "#4f08af"
  }), /*#__PURE__*/React.createElement("text", {
    id: "If_you_receive_any_question_from_the_client_on_the_response_shared._Copy_paste_the_question_and_send_to_the_same_internal_email_chain_with_pre-sales_team._",
    "data-name": "If you receive any question from the client on the response shared. Copy paste the question and send to the same internal email chain with pre-sales team. \\u200B",
    transform: "translate(127.287 367.213)",
    fill: "#191817",
    fontSize: 12,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500,
    letterSpacing: "0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 5,
    y: 13
  }, "If you receive any question from the "), /*#__PURE__*/React.createElement("tspan", {
    x: 5,
    y: 35
  }, "client on the response shared. Copy "), /*#__PURE__*/React.createElement("tspan", {
    x: 8,
    y: 57
  }, "paste the question and send to the "), /*#__PURE__*/React.createElement("tspan", {
    x: 5,
    y: 79
  }, "same internal email chain with pre-"), /*#__PURE__*/React.createElement("tspan", {
    x: 81,
    y: 101
  }, "sales team. \u200B"))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiddingStage);
export default __webpack_public_path__ + "static/media/biddingStage.91611d27acb89d4b30ff69ee0939937d.svg";
export { ForwardRef as ReactComponent };